import request, { deAxios } from '@/utils/request'
import { User } from '@/types'

const apiFactory = () => {
  const getList = (): Promise<User.API.ReqRes.UserActivity.Items> => {
    return request({
      url: 'cadence-service/users/me/activities/get-list',
      method: 'get'
    })
      .then(deAxios)
  }
  const createOne = (data: User.API.ReqRes.UserActivity.Item): Promise<User.API.ReqRes.UserActivity.Items> => {
    return request({
      url: '/cadence-service/users/me/activities/create',
      method: 'post',
      data
    })
      .then(deAxios)
  }
  const createMany = (data: User.API.ReqRes.UserActivity.Items): Promise<User.API.ReqRes.UserActivity.Items> => {
    return request({
      url: '/cadence-service/users/me/activities/create-list',
      method: 'post',
      data
    })
      .then(deAxios)
  }
  return { getList, createOne, createMany }
}

export default apiFactory
